import type { ZoneEntity } from './ZoneEntity'

export class RegionZonesEntity {
  regionId!: number
  zones: ZoneEntity[] = []
}
